import classNames from "classnames";

/**
 * A simple page divider.
 *
 * @constructor
 */
export function Divider({...props}): JSX.Element {
  return <div className={classNames("bg-gray-300 h-px my-8 w-full container mx-auto", props.className)}></div>
}